export const errorTrackingEvents = {
  SERVICE_MANIPULATED: "error-tracking-service-manipulated",
  CREATED: "created",
  UPDATED: "updated",
  DELETED: "deleted",
};
